import axios from "axios";

export default axios.create({
  baseURL: window.CtxAppConfigurations.restUri
});
